import script from "./Button.vue?vue&type=script&setup=true&lang=js"
export * from "./Button.vue?vue&type=script&setup=true&lang=js"

import "./Button.vue?vue&type=style&index=0&id=30484818&scoped=true&lang=scss"

import exportComponent from "/Users/ilvinipitter/code/lider-fornecedores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30484818"]])

export default __exports__